/** System tag name applied to conversations initiated by an AI-written Commerce Agent outreach. */
export const COMMERCE_AGENT_TAG_NAME = "Commerce Agent Initiated";

/** System tag name applied to conversations initiated by a Recover template send. */
export const RECOVER_INITIATED_TAG_NAME = "Recover Initiated";

/** System tag name applied to conversations initiated by a non-Recover automation template send. */
export const AUTOMATION_OUTREACH_TAG_NAME = "Automation Outreach";

/** System tag name applied to conversations initiated by a campaign send (SMS or email). */
export const CAMPAIGN_OUTREACH_TAG_NAME = "Campaign Outreach";

/**
 * @deprecated remove once Support V1 is fully removed.
 */
export const LEGACY_COMMERCE_AGENT_TAG_NAME = "Text Concierge Initiated";

/**
 * @deprecated remove once Support V1 is fully removed.
 */
export const COMMERCE_AGENT_TAG_NAMES: readonly [string, ...string[]] = [
  COMMERCE_AGENT_TAG_NAME,
  LEGACY_COMMERCE_AGENT_TAG_NAME,
];

/** System tag name applied when the AI agent escalates a conversation to a human. */
export const AI_NEEDS_HELP_TAG_NAME = "AI_NEEDS_HELP";

/** System tag name applied when the AI agent flags a conversation as spam. */
export const SPAM_TAG_NAME = "SPAM";

/**
 * System tag name applied when AI Agent should not try to reply to future inbound messages on this ticket.
 * Useful for auto-reply systems that aren't spam but AI should still not try to reply.
 */
export const AI_NO_REPLY_TAG_NAME = "AI_NO_REPLY";

/** System tag name that excludes a conversation/ticket (and its CSAT) from analytics. */
export const EXCLUDE_ANALYTICS_TAG_NAME = "exclude analytics";

/**
 * @deprecated Use the top-level constants above for supportV2 code. These enum
 * values target the legacy MongoDB `Conversation.tagIds` pipeline; supportV2
 * `shopper_ai_tag` rows use the new strings.
 */
export enum AIConversationTag {
  NEEDS_HELP = "ai:needs_help",
  SPAM = "ai:no_reply",
  UNTAGGED = "UNTAGGED",
}
